import { render, staticRenderFns } from "./landscape.vue?vue&type=template&id=0846293c&scoped=true"
import script from "./landscape.vue?vue&type=script&lang=js"
export * from "./landscape.vue?vue&type=script&lang=js"
import style0 from "./landscape.vue?vue&type=style&index=0&id=0846293c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0846293c",
  null
  
)

export default component.exports